import LayoutBasic from "@/views/layouts/LayoutBasic";
import newReports2 from "@/views/reports/new2";
import expensesReport from "@/views/reports/expenses";
import PeriodReport from "@/views/reports/Period";
import mainReports from "@/views/reports/main";
import Cashbox from "@/views/reports/cashbox";
import AgentDailyReport from "@/views/reports/AgentDailyReport";
import AgentPeriodReport from "@/views/reports/AgentPeriodReport";
import AgentPeriodDrugReport from "@/views/reports/AgentPeriodDrugReport";
import Country from "@/views/reports/Country";
import HistoryReports from "@/views/reports/HistoryReports";
import Conversions from "@/views/reports/Conversions.vue";
import SalesFunnel from "@/views/reports/SalesFunnel.vue";
import ReportNonCash from "@/views/reports/NonCash.vue";
import DivisionSecretaryReport from "@/views/reports/secretaryReport.vue";
import OperationsPeriodReport from "@/views/reports/OperationsPeriodReport.vue";

const routes = {
  path: '/reports',
  component: LayoutBasic, // Change the desired Layout here,
  meta: {requiresAuth: true},
  children: [
    {
      path: 'secretary',
      name: 'DivisionSecretaryReport',
      component: DivisionSecretaryReport,
      // component: newReports,
      meta: {
        accessName: 'report/division/secretary'
      }
    },
    {
      path: 'new',
      name: 'newReports',
      component: newReports2,
      // component: newReports,
      meta: {
        accessName: 'runnerReport/edit'
      }
    },
    {
      path: 'non-cash',
      name: 'ReportNonCash',
      component: ReportNonCash,
      meta: {
        accessName: 'reports/nonCash'
      }
    },
    {
      path: 'history',
      name: 'HistoryReports',
      component: HistoryReports,
      meta: {
        accessName: 'reports/history'
      }
    },
    {
      path: 'country',
      name: 'CountryDrugReport',
      component: Country,
      meta: {
        accessName: 'reports/countryDrug'
      }
    },
    {
      path: 'conversions',
      name: 'ReportConversions',
      component: Conversions,
      meta: {
        accessName: 'reports/Conversions'
      }
    },
    {
      path: 'salesfunnel',
      name: 'ReportSalesFunnel',
      component: SalesFunnel,
      meta: {
        accessName: 'reports/SalesFunnel'
      }
    },
    {
      path: 'new2',
      name: 'newReports2',
      component: newReports2,
      meta: {
        accessName: 'runnerReport/edit'
      }
    },
    {
      path: 'expenses',
      name: 'expensesReport',
      component: expensesReport,
      meta: {
        accessName: 'reports/expenses'
      }
    },
    {
      path: 'period',
      name: 'PeriodReport',
      component: PeriodReport,
      meta: {
        accessName: 'reports/period'
      }
    },
    {
      path: 'all',
      name: 'mainReports',
      component: mainReports,
      meta: {
        accessName: 'runnerReport/edit'
      }
    },
    {
      path: 'cashbox',
      name: 'Cashbox',
      component: Cashbox,
      meta: {
        accessName: 'runnerReport/cashbox'
      }
    },
    {
      path: 'AgentDaily',
      name: 'AgentDailyReport',
      component: AgentDailyReport,
      meta: {
        accessName: 'reports/AgentDaily'
      }
    },
    {
      path: 'AgentPeriod',
      name: 'AgentPeriodReport',
      component: AgentPeriodReport,
      meta: {
        accessName: 'reports/AgentPeriod'
      },
    },
    {
      path: 'AgentPeriod/drug',
      name: 'AgentPeriodDrugReport',
      component: AgentPeriodDrugReport,
      meta: {
        accessName: 'reports/AgentPeriodDrug'
      }
    },
    {
      path: 'operations/period',
      name: 'OperationsPeriodReport',
      component: OperationsPeriodReport,
      meta: {
        accessName: 'reports/operations/period'
      }
    },
  ]
}

export default routes;
